import React from 'react';
import {
  Alert,
  Box,
  Button,
  Chip,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { FGrid } from '../grid';
import {
  IDeterminantReport,
  IReportTablePayload,
} from './determinantBudget.models';

type Props = {
  report: IDeterminantReport;
  payload: IReportTablePayload | null;
  loading: boolean;
  canRegenerate: boolean;
  onLoad: (code: string) => void;
  onRegenerate: (codes?: string[]) => void;
};
const DeterminantReportPanel: React.FC<Props> = ({
  report,
  payload,
  loading,
  canRegenerate,
  onLoad,
  onRegenerate,
}) => {
  const [code, setCode] = React.useState(
    report.tables?.[0]?.tablecode || 'TABLE_04'
  );
  React.useEffect(() => {
    if (code) onLoad(code);
  }, [code]);
  return (
    <Stack spacing={2}>
      <Alert severity={report.stale ? 'warning' : 'info'}>
        Tables 4–18 completeness: {report.completeness || 0}%{' '}
        {report.stale ? '— regeneration required.' : ''}
      </Alert>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1}
        alignItems={{ md: 'center' }}
      >
        <TextField
          select
          size="small"
          label="Consolidated Report Table"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          sx={{ minWidth: 360 }}
        >
          {(report.tables || []).map((t) => (
            <MenuItem key={t.tablecode} value={t.tablecode}>
              Table {t.tablenumber}: {t.title}
            </MenuItem>
          ))}
        </TextField>
        {payload?.table && (
          <Chip
            label={payload.table.status}
            color={
              payload.table.status === 'VALID'
                ? 'success'
                : payload.table.status === 'STALE'
                  ? 'warning'
                  : 'default'
            }
          />
        )}
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          disabled={!canRegenerate || loading}
          onClick={() => onRegenerate([code])}
        >
          Regenerate Selected
        </Button>
        <Button
          variant="outlined"
          disabled={!canRegenerate || loading}
          onClick={() => onRegenerate()}
        >
          Regenerate All
        </Button>
      </Stack>
      {payload ? (
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>
            Table {payload.table.tablenumber}: {payload.table.title}
          </Typography>
          <FGrid
            title=""
            rows={payload.rows || []}
            columns={payload.columns as any}
            getRowId={(r: any) => r.rid ?? r.id ?? r.code}
            height={520}
          />
        </Box>
      ) : (
        <Alert severity="info">
          Select a table to view its generated rows.
        </Alert>
      )}
    </Stack>
  );
};
export default DeterminantReportPanel;
